import React from 'react';
import { AvatarCircle, Subtitle, Chip } from '@/components/atoms';
import {
  Wrapper,
  RightArea,
  TitleArea,
  LabelArea,
  TopArea,
  Label,
  DescriptionArea,
} from './DepositListItem.styled';
import { IDepositItem } from '@/types';

const DepositListItem = (props: IDepositItem) => {
  const {
    compLogoImgUrl,
    savingName,
    compNm,
    interestMaxRate,
    interestRate,
    advtText,
    desc1,
    desc2,
    onClick,
  } = props;

  return (
    <Wrapper onClick={onClick}>
      <AvatarCircle src={compLogoImgUrl} alt="test" />
      <RightArea className="text-area">
        <TopArea>
          <TitleArea>
            <Subtitle level={4} color="gray-800" whiteSpaceWrap>
              {savingName}
            </Subtitle>
            <Subtitle level={6} whiteSpaceWrap>
              {compNm}
            </Subtitle>
          </TitleArea>
          {(interestRate || interestMaxRate) && (
            <LabelArea>
              {interestMaxRate && (
                <Label>
                  <Subtitle level={6} color="primary-100">
                    최고 연&nbsp;
                  </Subtitle>
                  <Subtitle level={1} color="primary-100">
                    {+interestMaxRate + +interestRate}%
                  </Subtitle>
                </Label>
              )}
              {interestRate && <Subtitle level={6}>기본 연 {interestRate}%</Subtitle>}
            </LabelArea>
          )}
        </TopArea>
        {interestRate && (
          <div>
            <Chip>{`이자 ${interestRate}% 지원`}</Chip>
          </div>
        )}
        {(advtText || desc1) && (
          <DescriptionArea>
            {advtText && (
              <Subtitle level={6} color="primary-100" whiteSpaceWrap>
                {advtText}
              </Subtitle>
            )}
            {desc1 && (
              <Subtitle level={6} color="gray-800" whiteSpaceWrap>
                {desc1}
              </Subtitle>
            )}
          </DescriptionArea>
        )}
        <Subtitle level={9} color="gray-500" whiteSpaceWrap>
          {desc2}
        </Subtitle>
      </RightArea>
    </Wrapper>
  );
};

export default React.memo(DepositListItem);
